import './ModalPopup.css';
import React, {useState} from "react";

const ModalPopup = ({ show, onClose, children }) => {
    const [showModal, setShowModal] = useState(show);

    if (!showModal) return;

    const _onClose = (e) => {
        setShowModal(false);
        if (onClose) {
            onClose();
        }
    }

    return (
        <div className={`modal-popup`}>
            <div className={'modal-popup-background'} onClick={_onClose}/>
            <div className={'modal-popup-content'}>
                {children}
            </div>
        </div>
    )
}

export default ModalPopup;